export const demoTrips = [
    {
        id: '1',
        // Dhaka ⇄ Chittagong: ~245-265 km (via Dhaka-Chittagong Highway)
        // Estimated Fare Calculation: (255 km * BDT 35/km) + BDT 500 (tolls/driver buffer) = 8925 + 500 = BDT 9425
        fare: 9500, // Realistic one-way fare for a standard AC car (sedan)
        startTime: '2024-06-10T07:00:00', // Earlier start for long trip
        expectedEndTime: '2024-06-10T14:30:00', // 6-7.5 hours with traffic/rest stops
        upPoint: 'Dhaka',
        endPoint: 'Chittagong',
        distance: 255, // Adjusted distance for realism
        driverName: 'Jamal Hossain',
        carNumber: 'DHA METRO GA 14-8765' // More realistic BD plate
    },
    {
        id: '2',
        // Khulna ⇄ Jessore: ~55-60 km
        // Estimated Fare Calculation: (58 km * BDT 40/km) + BDT 200 (buffer for short trip/driver) = 2320 + 200 = BDT 2520
        fare: 2600, // Realistic one-way fare for a shorter inter-city trip
        startTime: '2024-06-10T09:30:00',
        expectedEndTime: '2024-06-10T11:00:00', // ~1.5 hours
        upPoint: 'Khulna',
        endPoint: 'Jessore',
        distance: 58, // Adjusted distance
        driverName: 'Abul Kashem',
        carNumber: 'KHU METRO GHA 11-2345' // More realistic BD plate
    },
    {
        id: '3',
        // Sylhet ⇄ Dhaka: ~250-265 km (via Dhaka-Sylhet Highway)
        // Estimated Fare Calculation: (260 km * BDT 36/km) + BDT 600 (tolls/driver buffer) = 9360 + 600 = BDT 9960
        fare: 10000, // Realistic one-way fare for a standard AC car (sedan)
        startTime: '2024-06-10T06:30:00', // Early start for long trip
        expectedEndTime: '2024-06-10T14:00:00', // 7-7.5 hours with traffic/rest stops
        upPoint: 'Sylhet',
        endPoint: 'Dhaka',
        distance: 260, // Adjusted distance
        driverName: 'Nazmul Hasan',
        carNumber: 'SYL METRO CHA 13-4567' // More realistic BD plate
    }
];